if (!customElements.get('ss-product-reassurance')) {
  customElements.define('ss-product-reassurance', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.sliderMobile !== 'true') return;

      this.rail = this.querySelector('[data-ss-pr-rail]');
      if (!this.rail) return;

      this.slides = Array.from(this.rail.children);
      if (this.slides.length < 2) return;

      this.dotsEl = this.querySelector('[data-ss-pr-dots]');
      this.wantsAutoplay = this.dataset.autoplay === 'true' && !SS.reduceMotion();
      this.delay = Number(this.dataset.autoplayDelay) || 4000;

      this.onScroll = SS.rafThrottle(this.syncDots.bind(this));
      this.onPointerDown = () => this.pause();
      this.onPointerUp = () => this.resume();

      this.cleanup = [
        SS.onBreakpoint(
          '(max-width: 749px)',
          () => this.enable(),
          () => this.disable()
        )
      ];
    }

    disconnectedCallback() {
      this.disable();
      this.cleanup?.forEach((fn) => fn());
    }

    /* ---------- Cycle de vie ---------- */

    enable() {
      if (this.active) return;
      this.active = true;

      this.rail.addEventListener('scroll', this.onScroll, { passive: true });
      this.buildDots();
      this.syncDots();

      if (!this.wantsAutoplay) return;

      // Suspension pendant l'interaction
      this.rail.addEventListener('pointerdown', this.onPointerDown);
      this.rail.addEventListener('pointerup', this.onPointerUp);
      this.rail.addEventListener('pointercancel', this.onPointerUp);
      this.addEventListener('mouseenter', this.onPointerDown);
      this.addEventListener('mouseleave', this.onPointerUp);
      this.addEventListener('focusin', this.onPointerDown);
      this.addEventListener('focusout', this.onPointerUp);

      // Ne tourne que si la section est à l'écran
      this.io = new IntersectionObserver(([entry]) => {
        entry.isIntersecting ? this.start() : this.stop();
      }, { threshold: 0.3 });
      this.io.observe(this);

      document.addEventListener('visibilitychange', this.onVisibility = () => {
        document.hidden ? this.stop() : this.start();
      });
    }

    disable() {
      if (!this.active) return;
      this.active = false;

      this.stop();
      this.io?.disconnect();
      this.rail.removeEventListener('scroll', this.onScroll);
      this.rail.removeEventListener('pointerdown', this.onPointerDown);
      this.rail.removeEventListener('pointerup', this.onPointerUp);
      this.rail.removeEventListener('pointercancel', this.onPointerUp);
      this.removeEventListener('mouseenter', this.onPointerDown);
      this.removeEventListener('mouseleave', this.onPointerUp);
      this.removeEventListener('focusin', this.onPointerDown);
      this.removeEventListener('focusout', this.onPointerUp);
      if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);

      if (this.dotsEl) {
        this.dotsEl.setAttribute('hidden', '');
        this.dotsEl.innerHTML = '';
      }
      this.dots = [];
    }

    /* ---------- Autoplay ---------- */

    start() {
      if (!this.active || !this.wantsAutoplay || this.timer || this.paused) return;
      this.timer = setInterval(() => this.next(), this.delay);
    }

    stop() {
      clearInterval(this.timer);
      this.timer = null;
    }

    pause() {
      this.paused = true;
      this.stop();
    }

    resume() {
      this.paused = false;
      this.start();
    }

    next() {
      const index = (this.currentIndex() + 1) % this.slides.length;
      this.goTo(index);
    }

    /* ---------- Navigation ---------- */

    currentIndex() {
      const center = this.rail.scrollLeft + this.rail.clientWidth / 2;
      let best = 0;
      let min = Infinity;

      this.slides.forEach((slide, i) => {
        const dist = Math.abs(slide.offsetLeft + slide.offsetWidth / 2 - center);
        if (dist < min) { min = dist; best = i; }
      });
      return best;
    }

    goTo(index) {
      const slide = this.slides[index];
      if (!slide) return;
      const left = slide.offsetLeft - (this.rail.clientWidth - slide.offsetWidth) / 2;
      this.rail.scrollTo({ left, behavior: SS.reduceMotion() ? 'auto' : 'smooth' });
    }

    /* ---------- Puces ---------- */

    buildDots() {
      if (!this.dotsEl || this.dataset.dots !== 'true') return;

      this.dotsEl.innerHTML = '';
      this.slides.forEach((_, i) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'ss-pr__dot';
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', `Argument ${i + 1} sur ${this.slides.length}`);
        dot.addEventListener('click', () => {
          this.pause();
          this.goTo(i);
          setTimeout(() => this.resume(), this.delay);
        });
        this.dotsEl.appendChild(dot);
      });

      this.dots = Array.from(this.dotsEl.children);
      this.dotsEl.removeAttribute('hidden');
    }

    syncDots() {
      const index = this.currentIndex();
      this.dots?.forEach((dot, i) => {
        dot.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });
    }
  });
}